import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=254f1acd&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('254f1acd')) {
      api.createRecord('254f1acd', component.options)
    } else {
      api.reload('254f1acd', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=254f1acd&", function () {
      api.rerender('254f1acd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gE1Q67ct3146/JS/comp/childrenage.vue"
export default component.exports